import { useEffect, useState } from "react";
import { componentStyles } from "./live-board-homepage-first-fold-component.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureComponent from "/components/core/picture/picture-component";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import Title from "segments/desktop/core-components/title/title";
import classNames from "classnames";
import { XS } from "constants/sizes";
import { WHITE_COLOR_NAME, BRAND_PRIMARY_GREEN } from "styles/color-consts";
import DefaultProps from "./default-props";
import { LIVE_BOARD_OPEN_BUTTON_HOVERED, LIVE_BOARD_SCALED } from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import { isSafari } from "services/user-agent-service";
function LiveBoardHomepageFirstFoldComponent(props) {
  const [scale, setScale] = useState(1);
  const [scrollEventSent, setScrollEventSent] = useState(false);

  const BOARDS_IMAGE_URL =
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/boards/v2_boards.png";
  const LIVE_BOARD_IMAGE =
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/boards/v2_demo_board.png";

  const { openLiveBoard, showLiveBoardImage, translate, liveBoardClosed } = props;
  const [showButton, setShowButton] = useState(liveBoardClosed);
  const [initialScalingValue, setInitialScalingValue] = useState(1.25);
  const [scalingValueInitiated, setScalingValueInitiated] = useState(false);

  const liveBoardOpenButtonClicked = () => {
    openLiveBoard();
  };

  const liveBoardOpenButtonHovered = () => {
    trackEvent(LIVE_BOARD_OPEN_BUTTON_HOVERED);
  };

  const getDistance = () => {
    return window.scrollY - window.innerHeight * 0.2;
  };

  const isAnimationRendered = () => {
    if (!liveBoardClosed && scale > 1.2 && initialScalingValue < 1.05 && !scrollEventSent) {
      setScrollEventSent(true);
    }
    return !liveBoardClosed && scale > 1.2 && initialScalingValue < 1.05;
  };

  useEffect(() => {
    document.body.addEventListener("wheel", handleScroll);
    return () => {
      document.body.removeEventListener("wheel", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (scrollEventSent) trackEvent(LIVE_BOARD_SCALED);
  }, [scrollEventSent]);

  useEffect(() => {
    const distance = getDistance();
    if (scalingValueInitiated) {
      setInitialScalingValue(1 + (distance / window.innerHeight) * 0.8);
    }
  }, [scalingValueInitiated]);

  const handleScroll = (e) => {
    const distance = getDistance();
    if (distance > 0) {
      requestAnimationFrame(() => {
        if (!isSafari()) {
          if (!scalingValueInitiated) {
            setScalingValueInitiated(true);
          }
          setScale(Math.min(1 + (distance / window.innerHeight) * 0.8, 1.25));
        }
      });
      if (!showButton) {
        setShowButton(true);
      }
    } else {
      setScale(1);
    }
  };

  return (
    <div
      className={classNames("live-board-homepage-first-fold-component", {
        "full-height": isAnimationRendered()
      })}
    >
      <div
        className={classNames("boards-picture", {
          opacity: isAnimationRendered()
        })}
      >
        <PictureComponent src={BOARDS_IMAGE_URL} />
      </div>
      <div
        className={classNames("live-board-wrapper", {
          "full-size": !showLiveBoardImage,
          scale: isAnimationRendered()
        })}
      >
        <div className={classNames("animation-circle", { "hide-button": !showButton })} />
        <div className={classNames("open-button-wrapper", { "hide-button": !showButton })}>
          <div className="open-button-content-wrapper" onMouseEnter={liveBoardOpenButtonHovered}>
            <div className="open-button-title-wrapper">
              <Title
                title={translate("liveBoard.openPopUpTitleText")}
                titleSize={XS}
                titleColor={BRAND_PRIMARY_GREEN}
              />
            </div>
            <div className="open-button-paragraph-wrapper">
              <Paragraph body={translate("liveBoard.openPopUpBodyText")} bodyColor={WHITE_COLOR_NAME} />
            </div>
            <div className="open-button-button-wrapper">
              <RegularButton
                buttonText={translate("liveBoard.openPopUpButtonText")}
                onClick={liveBoardOpenButtonClicked}
                color={WHITE_COLOR_NAME}
                isWithArrow={false}
              />
            </div>
          </div>
        </div>

        <div className="live-board-image-wrapper">
          <PictureComponent src={LIVE_BOARD_IMAGE} />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
}

LiveBoardHomepageFirstFoldComponent.defaultProps = DefaultProps;

export default withGenericConfig(LiveBoardHomepageFirstFoldComponent);
